module.exports = __webpack_public_path__ + "img/tag.247a67c3.svg";